import React from 'react';
import styled from 'styled-components';

import PictureComponent, {
  PictureProps,
} from '@rebound/design-system/components/Picture';

const Picture = (props: PictureProps) => <PictureComponent {...props} />;

export const NonReturnableOverlay = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  color: ${(props) => props.theme.colors.white};
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  background: rgba(59, 61, 71, 0.8);
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
`;

export default Picture;
